<script>
import tippy from 'sveltejs-tippy';
import { Navigate } from 'svelte-router-spa';


const hotels_props = {
	content: 'View hotels (Google Sheet)',
	allowHTML: true,
	placement: 'bottom',
}


let active = false;


function changeActive() {
	active = !active;
}

function closeActive() {
	active = false;
}

</script>



<style>

#my-navbar {

}


:global(.navbar-item span) {
	display: block;
	width: 100%;
	/*height: 100%;*/
}


@media (max-width: 1024px) {

	:global(.navbar-menu .navbar-item) {
		padding: 0 !important;
	}

	:global(.navbar-menu .navbar-item span) {
		padding: 0.5rem 0.75rem !important;
	}

}


.navbar-item.has-dropdown .navbar-link {
	background: transparent;
	color: var(--text-white);
}

.navbar-item.has-dropdown .navbar-link:hover {
	color: var(--text-white);
	background: transparent !important;
}

:global(.navbar-item.has-dropdown .navbar-link:hover .navbar-item span) {
	text-decoration: underline;
}

.navbar-link:not(.is-arrowless)::after {
	border: 2px solid var(--text-white);
	border-top: 0;
	border-right: 0;
	border-radius: 0 !important;
	font-size: 0.725rem !important;
}

.navbar-dropdown {
	border-top: 0;
	border-radius: 0;
	border-bottom-left-radius: 0.25rem;
	border-bottom-right-radius: 0.25rem;
	background: #000 !important;
	padding-bottom: 0.75rem;
}

.navbar-dropdown.is-right {
	border-top-right-radius: 0rem !important;
}

:global(.navbar-dropdown .navbar-item) {
	color: var(--text-white) !important;
	font-size: 0.975rem !important;
	text-decoration: none !important;
	padding: 0.25rem 0.875rem !important;
	padding-right: 2.25rem;
}

.navbar-link:not(.is-arrowless) {
	padding-right: 1.925rem !important;
}

.navbar-item.has-dropdown:hover .navbar-link {
	/*background-color: #232323 !important;*/
}

:global(.navbar-dropdown .navbar-item:hover) {
	color: var(--text-white) !important;
	text-decoration: underline !important;
	opacity: 1;
	transition: all ease 0.15s !important;
}


:global(.navbar-dropdown .navbar-item:hover) {
	color: var(--text-white) !important;
	text-decoration: underline !important;
	opacity: 1;
	transition: all ease 0.15s !important;
}


</style>



<nav class="navbar is-fixed-top" id="my-navbar">

	<div class="container">


		<div class="navbar-brand">

			<Navigate to="/my/teams" styles="navbar-item" on:click={closeActive}>
				<img src="/img/logo.png" style="width: 37px !important;">
				<span>Coaches</span>
			</Navigate>

			<a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbar-items" on:click={changeActive} class:is-active={active}>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
			</a>

		</div>


		<div class="navbar-menu" id="navbar-items" class:is-active={active}>


			<div class="navbar-start">

				<Navigate styles="navbar-item" to="/my/teams" on:click={closeActive}>
					<span on:click={closeActive}>My Teams</span>
				</Navigate>


				<Navigate styles="navbar-item" to="/my/programs" on:click={closeActive}>
					<span on:click={closeActive}>My Programs</span>
				</Navigate>


				<!-- <Navigate styles="navbar-item" to="/my/camps" on:click={closeActive}>
					<span on:click={closeActive}>My Camps</span>
				</Navigate> -->


				<!-- <a class="navbar-item" href="/my/resources" on:click={closeActive}>
					<span>Resources</span>
				</a> -->


				<!-- <a class="navbar-item" href="/my/schedules" on:click={closeActive}>
					<span>Schedules</span>
				</a> -->


				<!-- <a class="navbar-item" href="https://docs.google.com/spreadsheets/d/1FUehz46yZ-foGzp9tlbM8e7oVSjzlacpenfZzNNYLPU/edit?usp=sharing" target="_blank" rel="noopener">
					<span>Hotels</span>
					<i class="far fa-long-arrow-up"></i>
				</a> -->


				<!-- nice search bar! off-grey -->

			</div>


			<div class="navbar-end">

				<!-- <a class="navbar-item" href="/my/settings" on:click={closeActive}>
					<span>Settings</span>
				</a> -->

				<!-- <a class="navbar-item" href="https://docs.google.com/spreadsheets/d/1FUehz46yZ-foGzp9tlbM8e7oVSjzlacpenfZzNNYLPU/edit?usp=sharing" target="_blank" rel="noopener" use:tippy={hotels_props}>
					<span>Hotels</span>
					<i class="far fa-long-arrow-up"></i>
				</a> -->

				<div class="navbar-item has-dropdown is-hoverable" style="z-index: 100;">


					<a class="navbar-link">
						<span style="text-decoration: underline !important;">Important Info</span>
					</a>

					<div class="navbar-dropdown is-right" style="z-index: 10001;">


						<a class="navbar-item" href="https://docs.google.com/forms/d/e/1FAIpQLSeqKcZ986TwpT8DOdeocqzplh9UpLK6s2-fe3dyfvckZpymDg/viewform?usp=header">
							<span>1/4 Zip Form</span>
						</a>

						<!-- <a class="navbar-item" href="https://forms.gle/FribGBJYQmr3J8cV9">
							<span>Drill Book Form</span>
						</a> -->

						<!-- <Navigate styles="navbar-item" to="/my/irps" on:click={closeActive}>
							<span on:click={closeActive}>Spring Independently Registered Players</span>
						</Navigate>


						<Navigate styles="navbar-item" to="/my/free-agents" on:click={closeActive}>
							<span on:click={closeActive}>Spring Free Agents</span>
						</Navigate> -->

						<a class="navbar-item" href="https://www.canva.com/design/DAFMgfhznaU/KwwWSixkGZgCVHIJjzkUQQ/edit?utm_content=DAFMgfhznaU&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton" target="_blank" rel="noopener">
							<span>Coaches Guide</span>
						</a>


						<a class="navbar-item" href="/files/AHG-CODE-OF-CONDUCT-2025.pdf" target="_blank" rel="noopener">
							<span>Code of Conduct</span>
						</a>


						<!-- <a class="navbar-item" href="/files/NBSelectionCriteria2025.docx" target="_blank" rel="noopener">
							<span>NB Selection Criteria 2025</span>
						</a> -->


						<!-- <a class="navbar-item" href="/files/NSSelectionCriteria2025.docx" target="_blank" rel="noopener">
							<span>NS Selection Criteria 2025</span>
						</a> -->


						<Navigate styles="navbar-item" to="/my/resources" on:click={closeActive}>
							<span on:click={closeActive}>Coaches Resources</span>
						</Navigate>


						<!-- <Navigate styles="navbar-item" to="/my/free-agents" on:click={closeActive}>
							<span on:click={closeActive}>Free Agents List</span>
						</Navigate> -->


						<Navigate styles="navbar-item" to="/my/hotels" on:click={closeActive}>
							<span on:click={closeActive}>Hotels</span>
						</Navigate>


						<Navigate styles="navbar-item" to="/my/goalie-clinics" on:click={closeActive}>
							<span on:click={closeActive}>Goalie Clinics</span>
						</Navigate>


						<Navigate styles="navbar-item" to="/my/rules-and-format" on:click={closeActive}>
							<span on:click={closeActive}>Rules and Format</span>
						</Navigate>


						<!-- <a class="navbar-item" href="https://forms.gle/VbSzDSZTSeVV66JM7">
							<span>1/4 Zip Form</span>
						</a> -->
						
						
						<!-- <a class="navbar-item" href="https://atlantichockeygroupshop.com/products/ahg-coach-tracksuits">
							<span>AHG Coach Tracksuits</span>
						</a> -->


						<a class="navbar-item" href="https://ahgcentral.sportngin.com/register/form/247941342">
							<span>Affiliate Player Online Form</span>
						</a>


						<!-- <Navigate styles="navbar-item" to="/my/covid" on:click={closeActive}>
							<span on:click={closeActive}>Covid Rules</span>
						</Navigate> -->


						<Navigate styles="navbar-item" to="/my/faq" on:click={closeActive}>
							<span on:click={closeActive}>FAQ</span>
						</Navigate>


					</div>

				</div>


				<Navigate styles="navbar-item" to="/my/contact" on:click={closeActive}>
					<span on:click={closeActive}>Contact</span>
				</Navigate>	


				<Navigate styles="navbar-item" to="/logout" on:click={closeActive}>
					<!-- how to do this? -->
					<span on:click={closeActive}>Logout</span>
				</Navigate>

			</div>


		</div>


	</div>

</nav>


